import { render, staticRenderFns } from "./ListChangeView.vue?vue&type=template&id=2e509b88&scoped=true&"
import script from "./ListChangeView.vue?vue&type=script&lang=ts&"
export * from "./ListChangeView.vue?vue&type=script&lang=ts&"
import style0 from "./ListChangeView.vue?vue&type=style&index=0&id=2e509b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e509b88",
  null
  
)

export default component.exports